import React, { Component } 	from "react"
import { connect } 				from 'react-redux'
import { post, get } 			from '../../services/apiServices'
import { token } 				from '../../services/authServices'
import { withStyles } 			from 'material-ui/styles'
import { CircularProgress } 	from 'material-ui/Progress'
import ReactPaginate 			from 'react-paginate'
import Icon 					from 'material-ui/Icon'
import Button 					from 'material-ui/Button'
import TextField 				from 'material-ui/TextField'
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow } 					from 'material-ui/Table'
import Dialog, {
	DialogContent,
	DialogActions,
	DialogTitle } 				from 'material-ui/Dialog'

const styles = {
	progressWrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    progress: {
    },
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	tableRow: {
		cursor: 'pointer'
	},
	inputWrap: {
		marginBottom: '20px'
	},
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	justifyCenter: {
		justifyContent: 'center'
	}
}

class Players extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'open' : false,
			'players' : null,
			'id' : null,
			'first_name' : '',
			'last_name' : '',
			'player_name' : '',
			'password' : '',
			'errors' : {}
		}
	}

	getPlayers = id => {
		this.props.initPlayers(this.props.accountId, id).then(res => {
			this.setState({'players' : this.props.players})
		})
	}

	getSinglePlayer = id => {
		const classRoomId = this.props.classRoomId

		get(`/admin/accounts/${this.props.accountId}/classes/${classRoomId}/players/${id}`, token).then(res => {
			let response = res.data

			if (response.data) {
				let player = response.data

				this.setState({
					'id' : player.id,
					'first_name' : player.first_name,
					'last_name' : player.last_name,
					'player_name' : player.player_name,
					'password' : player.password
				})

				this.handleToggleModal(true)
			}
		})
	}

	onSubmit = () => {
		const {id, first_name, last_name, player_name, password} = this.state
		const classRoomId = this.props.classRoomId

		let playerId = id ? `/${id}` : ''
		let data = {
			'first_name' : first_name,
			'last_name' : last_name,
			'player_name' : player_name
		}

		if (password.length)
			data.password = password

		post(`/admin/accounts/${this.props.accountId}/classes/${classRoomId}/players${playerId}`,
			data,
			token,
			err => {
				let response = JSON.parse(err._bodyText)

				this.setState({'errors' : response.errors})
			}).then(res => {
				let response = res.data
				if (response.data) {
					this.getPlayers(this.props.classRoomId)
					this.handleToggleModal(false)
				}
			})
	}

	handleInputChange = e => {
  	  let state = this.state
  	  state[e.target.name] = e.target.value

  	  this.setState(state)
    }

	handleToggleModal = bool => {
		if (!bool)
			this.setState({
				'id' : null,
				'first_name' : '',
				'last_name' : '',
				'player_name' : '',
				'password' : ''
			})

		this.setState({'open' : bool})
	}

	handlePageChange = action => {
		this.props.pageChange(this.props.accountId, action.selected + 1).then(res => {
			this.setState({'players' : this.props.players})
		})
	}

	renderPlayersList = () => {
		let players = this.state.players.data
		let result = []

		players.map(player => {
			result.push(
				<TableRow key={player.id}>
					<TableCell padding="none">
						{player.first_name}
					</TableCell>
					<TableCell padding="none">
						{player.last_name}
					</TableCell>
					<TableCell padding="none">
						{player.player_name}
					</TableCell>
					<TableCell padding="none">
						{player.updated_at.date}
					</TableCell>
					<TableCell padding="none">
						<Icon
							className={this.classes.editIcon}
							onClick={(e) =>
								this.getSinglePlayer(player.id, e)}>
							mode_edit
						</Icon>
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	componentWillMount() {
		this.getPlayers(this.props.classRoomId)
	}

	classes = this.props.classes

	render() {
		const { players,
			id,
			first_name,
			last_name,
			player_name,
			password,
			errors } = this.state
		let isFetching = players ? players.isFetching : true
		let disable = first_name.length < 3 || last_name.length < 3
			|| player_name.length < 3
			|| (password && password.length) ? password.length < 3 : !id

		return(
			isFetching ?
			<div className={this.classes.progressWrapper}>
				<CircularProgress
					className={this.classes.progress}
					size={50}
				/>
			</div>
			:
			<div>
				<Dialog
					open={this.state.open}
					onClose={() => this.handleToggleModal(false)}>
					<DialogTitle>
						<Icon
							className={this.classes.closeIcon}
							onClick={() => this.handleToggleModal(false)}>
							close
						</Icon>
						{id ? 'Edit' : 'Add'} player
					</DialogTitle>
					<DialogContent>
						<div className={this.props.classes.inputWrap}>
							<TextField
								error={errors.first_name}
								label="First name"
								name="first_name"
								value={first_name}
								onInput={this.handleInputChange}
								helperText={
									errors.first_name ?
										errors.first_name[0] : false
								}
							/>
						</div>
						<div className={this.props.classes.inputWrap}>
							<TextField
								error={errors.last_name}
								label="Last name"
								name="last_name"
								value={last_name}
								onInput={this.handleInputChange}
								helperText={
									errors.last_name ?
										errors.last_name[0] : false
								}
							/>
						</div>
						<div className={this.props.classes.inputWrap}>
							<TextField
								error={errors.player_name}
								label="Player name"
								name="player_name"
								value={player_name}
								onInput={this.handleInputChange}
								helperText={
									errors.player_name ?
										errors.player_name[0] : false
								}
							/>
						</div>
						<div className={this.props.classes.inputWrap}>
							<TextField
								error={errors.password}
								label="Password"
								type="password"
								name="password"
								value={password}
								onInput={this.handleInputChange}
								helperText={
									errors.password ?
										errors.password[0] : false
								}
							/>
						</div>
					</DialogContent>
					<DialogActions className={this.classes.justifyCenter}>
						<Button
							variant="raised"
							color="primary"
							onClick={this.onSubmit}
							disabled={disable}>
							{id ? 'Edit' : 'Add'}
						</Button>
					</DialogActions>
				</Dialog>
				<Button
						variant="raised"
						color="primary"
						onClick={this.props.back}>
						Back
					</Button>
				<div className={this.classes.titleWrap}>
					{
						players.data.length ?
						<h2 className={this.props.classes.title}>
							Players
						</h2>
						:
						<h2>
							Not found
						</h2>
					}
					<Button
						variant="raised"
						color="primary"
						onClick={() => this.handleToggleModal(true)}>
						Add player
					</Button>
				</div>
				{
					players.data.length ?
					<div>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell padding="none">
										FIRST NAME
									</TableCell>
									<TableCell padding="none">
										LAST NAME
									</TableCell>
									<TableCell padding="none">
										PLAYER NAME
									</TableCell>
									<TableCell padding="none">
										LAST UPDATE
									</TableCell>
									<TableCell padding="none">
										ACTION
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{this.renderPlayersList()}
							</TableBody>
						</Table>
					</div>
					: null
				}
			</div>
		)
	}
}

export default withStyles(styles)(Players)



// WEBPACK FOOTER //
// ./src/components/content/Players.js